import React from "react"
import { Box, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"

import { screenAbout } from "@app/@signals"
import { dsColorNew } from "@palette"
import { askTooltip } from "@utils/askIris/buttonState"
import AskIrisButton from "./AskIrisButton"
import useScreenHelp from "./useScreenHelp"

// The About text as the icon's tooltip (C8): white paper, readable, never clipped by the fixed header
const RICH_TOOLTIP = {
	placement: 'bottom-start',
	slotProps: {
		tooltip: { sx: {
			maxWidth: 400, p: 0, backgroundColor: dsColorNew.white, color: dsColorNew.textDark, borderRadius: '12px',
			border: `1px solid ${dsColorNew.grayBorder}`, boxShadow: `0 16px 40px ${alpha(dsColorNew.navy, 0.16)}`,
		} },
	},
}

function AboutTooltip({ about, reason }) {
	return <Box sx={{ px: 2, pt: 1.5, pb: 1.5 }}>
		{!!about.title && <Typography sx={{ fontSize: 14, fontWeight: 600, color: dsColorNew.textTitle, mb: 0.75 }}>{about.title}</Typography>}
		<Box sx={{ fontSize: 13, lineHeight: 1.55, color: dsColorNew.textDark, display: 'flex', flexDirection: 'column', gap: 1, '& p': { m: 0 } }}>
			{about.content}
		</Box>
		<Typography sx={{ fontSize: 12, color: dsColorNew.textMuted, mt: 1.25 }}>{reason || askTooltip('screen')}</Typography>
	</Box>
}

/**
 * Ask Iris in help mode (CU-869fmufdb): the shell header's icon, painted once for every screen with a help page
 * (UX C1). One click asks "What is {name} for, and how do I use it?" with the screen hint on that turn only.
 * Visible in every data state and during the tour (C7): only "no Iris" or "no page" hide it.
 */
export default function ScreenHelpButton() {
	const help = useScreenHelp()
	const about = screenAbout.value
	if (!help) return null

	// 6 px from the title (UX C4): the header row already puts an 8 px gap between its children
	return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', ml: '-2px', flexShrink: 0 }}>
		<AskIrisButton
			variant="screen"
			ariaLabel={`Ask Iris about this screen: ${help.name}`}
			tooltip={about ? reason => <AboutTooltip about={about} reason={reason}/> : undefined}
			tooltipProps={about ? RICH_TOOLTIP : {}}
			getAsk={() => ({ kind: 'screen', subject: help.name, help: help.hint })}
		/>
	</Box>
}
